// import { LoadingButton } from "@mui/lab";
import { Card, CardContent, FormControl, OutlinedInput, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../contexts/userContext";
import { IAlert } from "../../interfaces/alert";
import {
  CONFIGURATION_PERMISSION,
  ERROR,
  SUCCESS,
} from "../../utils/constants";
import GenericAlert from "../GenericAlert";
import ConfirmChangesButtons from "./ConfirmChangesButtons";
import { updatePostmarkSettings } from "../../requests/configurationRequests";
import { usePermission } from "../../customHooks/usePermission";

const PostmarkAccountSettings = () => {
  const { currentUser, refreshUserData } = useContext(UserContext);
  const [postmarkApiKey, setPostmarkApiKey] = useState(currentUser.postmarkApiKey || "");
  const [postmarkEmail, setPostmarkEmail] = useState(currentUser.postmarkEmail || "");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({} as IAlert);


  const { can_write } = usePermission(CONFIGURATION_PERMISSION);
  const handleSubmit = async () => {
    try {
      setLoading(true);
      await updatePostmarkSettings(
        { postmarkApiKey, postmarkEmail }
      );
      setAlert({
        typeOfAlert: SUCCESS,
        message: "La configuración de Postmark se ha actualizado correctamente.",
        showAlert: true,
      });
      setLoading(false);
      refreshUserData();
    } catch (error: any) {
      setAlert({ typeOfAlert: ERROR, message: error as string, showAlert: true });
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setPostmarkApiKey(currentUser?.postmarkApiKey || "");
    setPostmarkEmail(currentUser?.postmarkEmail || "");
  };

  useEffect(() => {
    setPostmarkApiKey(currentUser?.postmarkApiKey || "");
    setPostmarkEmail(currentUser?.postmarkEmail || "");
  }, [currentUser]);
  return (
    <>
      <Card
        className={`br-20 ${"bg-light m-b-40"}`}
        sx={{
          padding: 3,
          width: undefined,
        }}
      >
        <CardContent className="webhookContainer" sx={{ paddingInline: 4.5 }}>
          <>
            <Typography className="f-s-24">
              Configuración de su cuenta de Postmark
            </Typography>
            <div className="m-b-20">
              {alert.showAlert && <GenericAlert alert={alert} />}
            </div>
            <FormControl fullWidth sx={{ gap: 2, marginBottom: 2 }}>
              <Typography>
                  Ingresa el email asociado a tu cuenta de Postmark
              </Typography>
              <OutlinedInput
                autoFocus
                size="small"
                className="bg-input"
                disabled={!can_write}
                value={postmarkEmail}
                placeholder="email"
                onChange={({ target: { value } }) =>
                  setPostmarkEmail(value)
                }
              />
              <Typography>
                  Ingresa la apikey asociada a tu cuenta de Postmark
              </Typography>
              <OutlinedInput
                autoFocus
                size="small"
                className="bg-input"
                disabled={!can_write}
                value={postmarkApiKey}
                placeholder="API key"
                onChange={({ target: { value } }) =>
                  setPostmarkApiKey(value)
                }
              />
            </FormControl>
          </>
        </CardContent>
      </Card>
      <ConfirmChangesButtons
        handleConfirm={handleSubmit}
        handleCancel={handleCancel}
        disableConfirmButton={postmarkApiKey === "" || postmarkEmail === ""}
        confirmButtonText="Guardar cambios"
        loadingConfirmButton={loading}
      />
    </>
  );
};

export default PostmarkAccountSettings;
